import Groundwork from '@tghp/groundwork.js';
import siteHeaderComponent from './components/site-header'
import testimonialsSwiperComponent from './components/testimonials-swiper'
import teamBiosComponent from './components/team-bios'
import showPublicationsComponent from './components/show-publications'
import swiperComponent from './components/swiper'
const groundworkMain = new Groundwork('main');
groundworkMain.components.add('site-header', siteHeaderComponent);
groundworkMain.components.add('testimonials-swiper', testimonialsSwiperComponent);
groundworkMain.components.add('team-bios', teamBiosComponent);
groundworkMain.components.add('show-publications', showPublicationsComponent);
groundworkMain.components.add('swiper', swiperComponent);
groundworkMain.run();